import './alteration-card.scss'

import _ from 'lodash'
import { PropType } from 'vue'
import Component from "vue-class-component"
import { Watch } from 'vue-property-decorator'
import { faPen, faEllipsisH, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons'

import { Alteration, ThesaurusTerm, editTranslatedString, getTranslatedString } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { ThesaurusTermDataStore } from '@skinsoft/entity/src/thesaurusTerm'
import { ReactiveVue } from "@skinsoft/reactive-vue"
import { Media } from '@skinsoft/ui/src/item-card/media'
import ThesaurusTermTreeModal, { THESAURUS_TERM_SELECTED } from '@skinsoft/ui/src/thesaurus-term-tree/thesaurus-term-tree-modal'
import ThesaurusTermTree from '@skinsoft/ui/src/thesaurus-term-tree'

export const ALTERATION_CARD_DELETE_ALTERATION = 'alteration-card-delete-alteration'
export const ALTERATION_CARD_ALTERATION_UPDATED = 'alteration-card-alteration-type-updated'

export enum MainAlterationCardField {
    Title,
    AlterationType,
}

export interface AlterationChanged {
    index: number,
    updates: Partial<Alteration>
}

export type AlterationWithThesaurusTerm = Alteration & { typeOfAlterationObject: ThesaurusTerm | null }

@Component({
    components: {
        sMedia: Media,
        sThesaurusTermTreeModal: ThesaurusTermTreeModal,
        sThesaurusTermTree: ThesaurusTermTree,
    },
    props: {
        type: Array,
        alteration: {
            type: Object as PropType<AlterationWithThesaurusTerm>,
        },
        index: {
            type: Number,
        },
        mainField: {
            default: MainAlterationCardField.Title
        },
    },
    template: require('./alteration-card.html')
})
export default class AlterationCard extends ReactiveVue {
    private index: number
    private alteration: AlterationWithThesaurusTerm
    private mainField: MainAlterationCardField

    // @ts-ignore
    private updatedAlteration: AlterationWithThesaurusTerm = {}
    private isEditing = false
    private moreMenuOpen = false
    private isDeleteConfirmationOpen = false

    private $thesaurusTermDataStore: ThesaurusTermDataStore

    private editIcon = faPen
    private moreIcon = faEllipsisH
    private cancelIcon = faTimes
    private validateIcon = faCheck

    private THESAURUS_TERM_SELECTED = THESAURUS_TERM_SELECTED

    private MAIN_FIELD_TITLE = MainAlterationCardField.Title
    private MAIN_FIELD_ALTERATION_TYPE = MainAlterationCardField.AlterationType

    private mounted() {
        this.updatedAlteration = _.cloneDeep(this.alteration)
    }

    private onEditingCanceled() {
        this.updatedAlteration = _.cloneDeep(this.alteration)
        this.toggleEdit()
    }

    private openThesaurusTermModal() {
        // @ts-ignore
        this.$refs.alterationTypeModal.openModal()
        this.moreMenuOpen = false
    }

    private openTitleModal() {
        // @ts-ignore
        this.$refs.alterationTitleModal.show()
        this.moreMenuOpen = false
    }

    private onTypeOfAlterationChanged(thesaurusTermId: string) {
        this.updatedAlteration.typeOfAlteration = thesaurusTermId
        this.$thesaurusTermDataStore.fetchOne(thesaurusTermId)
            .subscribe(thesaurusTerm => {
                if(thesaurusTerm) {
                    this.updatedAlteration.typeOfAlterationObject = thesaurusTerm
                }else {
                    this.updatedAlteration.typeOfAlterationObject = null
                }
            })
    }

    private updateAlteration() {
        let updates = _.cloneDeep(this.updatedAlteration)
        // @ts-ignore
        delete updates.typeOfAlterationObject
        // @ts-ignore
        delete this.updatedAlteration.index

        this.$emit(ALTERATION_CARD_ALTERATION_UPDATED, { index: this.index, updates: updates } as AlterationChanged)
        this.toggleEdit()
    }

    private deleteAlteration() {
        this.$emit(ALTERATION_CARD_DELETE_ALTERATION, this.index)
    }

    private toggleEdit() {
        this.isEditing = !this.isEditing
        this.moreMenuOpen = false
    }

    private toggleMoreMenu() {
        this.moreMenuOpen = !this.moreMenuOpen
        this.isDeleteConfirmationOpen = false
    }

    private get mainFieldValue(): string {
        switch(this.mainField) {
            case MainAlterationCardField.Title:
                return getTranslatedString(this.updatedAlteration.title, this.$i18n.locale)
            case MainAlterationCardField.AlterationType:
                if(this.updatedAlteration.typeOfAlterationObject) {
                    return getTranslatedString(thesaurusTermSelectors.preferredTerm(this.updatedAlteration.typeOfAlterationObject), this.$i18n.locale)
                }
                break
        }

        return ''
    }

    private get updatedAlterationTitle(): string {
        return getTranslatedString(this.updatedAlteration.title, this.$i18n.locale)
    }
    private set updatedAlterationTitle(value: string) {
        editTranslatedString(this.updatedAlteration.title, value, this.$i18n.locale)
    }

    private get updatedAlterationPrecision(): string {
        return getTranslatedString(this.updatedAlteration.precision, this.$i18n.locale)
    }
    private set updatedAlterationPrecision(value: string) {
        editTranslatedString(this.updatedAlteration.precision, value, this.$i18n.locale)
    }

    @Watch('alteration')
    private onAlterationChanged() {
        this.updatedAlteration = _.cloneDeep(this.alteration)
        this.moreMenuOpen = false
        this.isEditing = false
    }
}